import { useNavigate } from "react-router-dom";

export default function CheckoutFailurePage() {
  const navigate = useNavigate();
  return (
    <div className="shell" data-testid="checkout-failure-page">
      <div
        className="panel"
        style={{
          maxWidth: 540,
          margin: "60px auto",
          padding: 36,
          textAlign: "center",
          border: "1px solid #ff8b8b55",
        }}
      >
        <div style={{ fontSize: 64, marginBottom: 8 }}>😕</div>
        <h2 style={{ marginBottom: 12 }}>تعذّر إتمام الدفع</h2>
        <p
          className="muted"
          style={{ lineHeight: 1.9, marginBottom: 22, fontSize: 15 }}
        >
          لم يتمّ خصم أيّ مبلغ. يمكنك المحاولة مجدّدًا أو اختيار وسيلة دفعٍ
          أخرى. إن استمرّت المشكلة، تواصل معنا عبر صفحة التواصل.
        </p>
        <div
          style={{
            display: "flex",
            gap: 12,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <button
            className="btn btn-primary"
            onClick={() => navigate("/pricing")}
            data-testid="failure-retry"
            style={{ padding: "12px 22px", fontWeight: 700 }}
          >
            المحاولة مجدّدًا
          </button>
          <button
            className="btn btn-ghost"
            onClick={() => navigate("/contact")}
            data-testid="failure-contact"
            style={{ padding: "12px 22px" }}
          >
            تواصل معنا
          </button>
        </div>
      </div>
    </div>
  );
}
